import { render, staticRenderFns } from "./editeFormMenu.vue?vue&type=template&id=45b7a16c&scoped=true&"
import script from "./editeFormMenu.vue?vue&type=script&lang=js&"
export * from "./editeFormMenu.vue?vue&type=script&lang=js&"
import style0 from "./editeFormMenu.vue?vue&type=style&index=0&id=45b7a16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7a16c",
  null
  
)

export default component.exports